import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommissionAdditionalCredit } from 'src/app/model/commission-additional-credit.model';
import { CommissionSimulatorService } from 'src/oldApp/services/commission-simulator.service';
import { of } from 'rxjs';

@Component({
  selector: 'app-modal-commission-additional-credit',
  templateUrl: './modal-commission-additional-credit.component.html'
})
export class ModalAdditionalCommissionCreditComponent implements OnInit {
  @Input() simulateDate:string;
  public additionalCredit:CommissionAdditionalCredit;
  public validCredit:boolean=false;
  public validPromotor:boolean=false;
  public ngbDateStruct:any;
  public validCommission:boolean=false;
  public viewStatus:number=0;

  // Mascaras
  public customPatterns={
    'N':{pattern:new RegExp('[0-9]')}
  };
  
  constructor(
    private modalService:NgbModal,
    private commissionService:CommissionSimulatorService,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    this.additionalCredit= new CommissionAdditionalCredit();
    this.viewStatus = 1;
  }

  onSelectDate(evt:any){
    let d = new Date(evt.year,evt.month-1,evt.day);
    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    this.ngbDateStruct = [year, month, day].join('-');
  }

  accept(){
    this.viewStatus=0;
    if(this.ngbDateStruct == undefined){
      this.toastr.error('Es necesario agregar la Fecha Cobrado');
    } else{
      this.additionalCredit.createdUser = localStorage.getItem("UserId");
      this.additionalCredit.isSimulate=1;
      this.additionalCredit.enviado=0;
      this.additionalCredit.executionDate=this.simulateDate;
      console.log("CREDITO ADICIONAL: " + JSON.stringify(this.additionalCredit));
      this.commissionService.saveCommissionCaneAdditionalCredit(this.additionalCredit)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.modalService.dismissAll(this.additionalCredit);
              this.toastr.success('Crédito agregado exitosamente');
            } else {
              this.toastr.error('Ocurrió un error al agregar el crédito');
            }
          });
    }
    this.viewStatus=1;
  }

  cancel(){
    this.modalService.dismissAll('failure');
  }

  getInfo(){
    if(!this.validCredit && !this.validPromotor) {
      this.toastr.info('Favor de ingresar datos');
    } else{
      if(this.validCredit && !this.validPromotor){
        this.getInfoCredit();
        this.toastr.info('Faltan datos promotor');
      } else if(this.validPromotor && !this.validCredit){
        this.getInfoPromotor();
        this.toastr.info('Faltan datos crédito');
      } 
      else if(this.validCredit && this.validPromotor){
        this.getInfoCredit();
        this.getInfoPromotor();
      }
    }
  }

  getInfoCredit(){
    this.commissionService.getInfoCredit(this.additionalCredit.idCredito)
    .subscribe((resp:any)=> {
      if(resp != null) {
        let credito = JSON.parse(JSON.stringify(resp));
        console.log(credito);
        console.log(credito.data);
        console.log(credito.data.size);
        if(credito.data.length > 0){
          this.additionalCredit.nombreCliente = credito.data[0].NOMBRE_CLIENTE;
          this.additionalCredit.producto = credito.data[0].PRODUCTO;
          this.additionalCredit.plazo = credito.data[0].PLAZO;
          this.additionalCredit.montoPagoCredito = credito.data[0].MONTO_PAGO_CREDITO;
          this.additionalCredit.fechaCobrado = credito.data[0].FECHA_COBRADO;
          this.additionalCredit.montoSolicitado = credito.data[0].MONTO_SOLICITADO;
          this.additionalCredit.capital = credito.data[0].CAPITAL;
          this.additionalCredit.dependencia = credito.data[0].DEPENDENCIA;
          this.additionalCredit.folioSolicitud = credito.data[0].FOLIO_SOLICITUD;
          this.additionalCredit.tipoPromocion = credito.data[0].TIPO_PROMOCION;
          this.additionalCredit.periodoPago = credito.data[0].PERIODO;
          this.additionalCredit.estado = credito.data[0].ESTADO;
          this.additionalCredit.zona = credito.data[0].ZONA;
          this.additionalCredit.colectivo = credito.data[0].COLECTIVO;

          if(this.additionalCredit.fechaCobrado != null){
            var date = new Date(this.additionalCredit.fechaCobrado);
            this.ngbDateStruct = { day: date.getUTCDate(), month: date.getUTCMonth() + 1, year: date.getUTCFullYear()};
          }
          
        }
        else {
          this.toastr.error('No se encontró información del crédito');
        } 
      } 
    });
  }

  getInfoPromotor(){
    this.commissionService.getInfoPromotor(this.additionalCredit.idPromotor)
    .subscribe((resp:any)=> {
      if(resp != null) {
        let promotor = JSON.parse(JSON.stringify(resp));
        console.log(promotor);
        console.log(promotor.comercial);
        if(promotor.comercial.length > 0){
          this.additionalCredit.nombrePromotor = promotor.comercial[0].nombreAsesor;
          this.additionalCredit.idSupervisor = promotor.comercial[0].cveSup;
          this.additionalCredit.nombreSupervisor = promotor.comercial[0].nombreSup;
          this.additionalCredit.idGerente = promotor.comercial[0].cveGte;
          this.additionalCredit.nombreGerente = promotor.comercial[0].nombreGte;
          this.additionalCredit.idSucursal = promotor.comercial[0].idSucursal;
          this.additionalCredit.nombreSucursal = promotor.comercial[0].s2ucursal;
        }
        else{
          this.toastr.error('No se encontró información del empleado');
        }     
      }
    });
  }

  validarCredito(){
    console.log("Valor credito: " +this.additionalCredit.idCredito)
    if(this.additionalCredit.idCredito > 0 || this.additionalCredit.idCredito.toString().length > 0 ){
      this.validCredit = true;
    } else{
      this.validCredit = false;
    }
  }

  validarPromotor(){
    console.log("Valor promotor: " +this.additionalCredit.idPromotor)
    if(this.additionalCredit.idPromotor.length > 0 ){
      this.validPromotor = true;
    } else{
      this.validPromotor = false;
    }
  }

  calculateCommission(){
    this.additionalCredit.montoComision = (Number(this.additionalCredit.capital)*(this.additionalCredit.porcentajeComision/100));

    if(this.additionalCredit.montoComision > 0){
      this.validCommission = true;
    }

  }
}